<template>
  <v-dialog v-model="dialog" width="876" persistent>
    <v-card class="custom-card" rounded="0">
      <v-toolbar color="secondary" class="white--text">
        <v-toolbar-title class="font-weight-bold" v-if="animalDisease.id">{{ $t("editCurrentRecord") }}
        </v-toolbar-title>
        <v-toolbar-title class="font-weight-bold" v-else>{{
            $t("addNewRecord")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form autocomplete="off" ref="form" v-model="valid" @submit.prevent="submitDisease" style="padding: 20px">
        <v-row style="padding: 20px">
          <v-col cols="12" v-if="animalDisease.id">
            <v-card flat color="transparent">
              <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
                <v-toolbar-title class="grey--text text--darken-2" style="font-size: 13px">
                  Do you really want to edit this record ? Your previous records
                  might get affected.
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
          </v-col>

          <v-col cols="6">
            <label class="label">
              {{ $t("animal.healthRecordInfo.clinicalSymptomsForm") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>
                  Observable e.g. diarrhea, limping, bloody discharge,
                  salivation, blindness, abortions
                </span>
              </v-tooltip>
            </label>

            <v-textarea class="scrollable-textarea" :rows="3" type="text" outlined dense :placeholder="$t('animal.healthRecordInfo.clinicalSymptomsForm')"
              v-model="animalDisease.clinicalSymptoms" :messages="symptomMessage">
              <template v-slot:prepend-inner>
                <div v-for="(chipText, index) in chipData" :key="index">
                  <v-chip close @click:close="remove(chipData[index])" class="ma-1" color="primary">
                    {{ chipText }}</v-chip>
                </div>
              </template>
            </v-textarea>

            <!--<v-text-field
              type="text"
              outlined
              dense
              :placeholder="$t('animal.healthRecordInfo.clinicalSymptomsForm')"
              v-model="animalDisease.clinicalSymptoms"
              :messages="symptomMessage"
            ></v-text-field>-->
            <!--<p>  <v-list-item-subtitle class="text-sm-right ">Enter multiple symptoms separated with commas ","</v-list-item-subtitle></p>-->
          </v-col>
        </v-row>
        <v-divider class="mt-3"></v-divider>
        <v-row style="padding: 20px">
          <v-col cols="6">
            <label class="label">
              {{ $t("animal.healthRecordInfo.tentativeDiagnosis") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>
                  A tentative diagnosis is a diagnosis that can neither be
                  confirmed or a conclusion can be made. While they may suspect,
                  and have good background history to support it, it's not a
                  confirmed diagnosis until all the results are in. No doctor is
                  going to give you a diagnosis when they need more information
                  (most of the time blood tests or body scans). It will be a
                  tentative diagnosis until then.
                </span>
              </v-tooltip>
            </label>
            <v-text-field type="text" outlined dense :placeholder="$t('animal.healthRecordInfo.tentativeDiagnosis')"
              v-model="animalDisease.tentativeDiagnosis"></v-text-field>
          </v-col>

          <v-col cols="6">
            <label class="label">
              {{ $t("animal.healthRecordInfo.sampleCollected") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>
                  Sample collected to make definite diagnosis e.g. blood, urine,
                  skin scrap, milk
                </span>
              </v-tooltip>
            </label>
            <v-select v-model="animalDisease.sampleCollected" v-if="animalDisease.sampleCollected !=='Others'" :items="sampleCollectedOptions" outlined dense
              placeholder="Select sample">
            </v-select>
          
            <v-text-field v-if="animalDisease.sampleCollected == 'Others'" type="text" outlined dense
                placeholder="Enter Sample" @click:clear="sampleClear" clearable
                v-model="animalDisease.otherSampleCollected"></v-text-field>
            <!-- <v-text-field
              type="text"
              
              outlined
              dense
              :placeholder="$t('animal.healthRecordInfo.sampleCollected')"
              v-model="animalDisease.sampleCollected"
            ></v-text-field>-->
          </v-col>
          <v-col cols="6">
            <label class="label">
              {{ $t("animal.healthRecordInfo.observationDate") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t("animal.healthRecordInfo.observationDate") }}</span>
              </v-tooltip>
            </label>
            <v-menu v-model="diseaseDateMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="animalDisease.diseaseDate" append-icon="mdi-calendar" outlined dense readonly
                  v-bind="attrs" v-on="on" v-on:click:append="diseaseDateMenu = true"
                  placeholder="Select date"></v-text-field>
              </template>
              <v-date-picker v-model="animalDisease.diseaseDate" @input="diseaseDateMenu = false"
                :max="getTodayDate"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <label class="label">
              {{ $t("animal.healthRecordInfo.nameOfVeterinarianNew") }}
              <v-tooltip top color="black" max-width="350">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{
                   $t("animal.healthRecordInfo.veterinarianTechnicianNameTooltip")
                }}</span>
              </v-tooltip>
            </label>
            <v-text-field type="text" outlined dense :placeholder="$t('animal.healthRecordInfo.veterinarianTechnicianNameTooltip')"
              v-model="animalDisease.veterinarianName"></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="" outlined color="primary" @click="closeModal" width="112">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn type="submit" width="112" color="primary" class="btn-11 btn-22">
            <span v-if="animalDisease.id">{{ $t("update") }}</span>
            <span v-else>{{ $t("submit") }}</span>
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import moment from "moment";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
    sampleCollectedOptions() {
      return ["Blood", "Urine", "Skin scrap", "Milk","Others"];
    },
    getTodayDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  watch: {
    // whenever question changes, this function will run
    "animalDisease.clinicalSymptoms": function (currentValue) {
      if (currentValue.includes(",")) {
        let values = currentValue.split(",");
        let filtered = values.filter(function (el) {
          return el != "";
        });

        let self = this;
        filtered.forEach(async (rating) => {
          self.chipData.push(rating);
        });
        this.animalDisease.clinicalSymptoms = "";
      }
    },
  },
  data() {
    return {
      diseaseDateMenu: false,
      chipData: [],
      symptomMessage: 'Enter multiple symptoms separated with commas ","',
      animalDisease: {
        id: null,
        animalId: parseInt(this.$route.params.animal_number),
        clinicalSymptoms: "",
        tentativeDiagnosis: "",
        sampleCollected: "",
        otherSampleCollected:"",
        diseaseDate: "",
        veterinarianName: "",
      },
      valid: true,
    };
  },
  methods: {
    remove(item) {
      this.chipData.splice(this.chipData.indexOf(item), 1);
    },
    closeModal() {
      this.$emit("closeAddDept");
    },
    
    sampleClear(){
      this.animalDisease.sampleCollected = ""
      this.animalDisease.otherSampleCollected = ""
    },

    async submitDisease() {
      if (!this.$refs.form.validate()) return;



      if(this.animalDisease.clinicalSymptoms == "" && 
            this.animalDisease.tentativeDiagnosis == "" && 
            // this.animalDisease.sampleCollected == "" && 
            this.animalDisease.diseaseDate == "" && 
            this.animalDisease.veterinarianName == "" 
        ) {
            this.$notify({
                    //title: `No details entered.`,
                    text: 'No details entered.',
                    type: "error",
                    position: "top right",
                });
            return;
        }


      this.startLoading();

      if (this.animalDisease.clinicalSymptoms.length > 0) {
        this.chipData.push(this.animalDisease.clinicalSymptoms);
        console.log(this.chipData, "this.chipDatathis.chipDatathis.chipData");
      }
      //console.log(this.chipData.join(","),"this.chipData.join")
      const animalDisease = {
        id: this.animalDisease.id,
        clinical_symptoms: this.chipData.join(","),
        tentative_diagnosis: this.animalDisease.tentativeDiagnosis,
        sample_collected: this.animalDisease.sampleCollected == 'Others' ? this.animalDisease.otherSampleCollected : this.animalDisease.sampleCollected,
        
        disease_date: this.animalDisease.diseaseDate == "" ? null : this.animalDisease.diseaseDate,
        veterinarian_name: this.animalDisease.veterinarianName,
        animalId: this.animalDisease.animalId,
      };

      let mutation = "";
      if (!animalDisease.id) {
        delete animalDisease.id;
        mutation = `mutation createAnimalDisease($data: CreateAnimalDiseaseInput!) {
                createAnimalDisease(createAnimalDiseaseInput: $data) {
                  id
                }
              }`;
      } else {
        mutation = `mutation updateAnimalDisease($data: UpdateAnimalDiseaseInput!) {
                updateAnimalDisease(updateAnimalDiseaseInput: $data) {
                  id
                }
              }`;
      }

      this.$apollo
        .mutate({
          mutation: gql`
            ${mutation}
          `,
          variables: {
            data: animalDisease,
          },
        })
        .then((response) => {
          if (!animalDisease.id) {
            if (response.data.createAnimalDisease) {
              this.$notify({
                title: `Disease added successfully`,
                text: response.message,
                type: "success",
                position: "top right",
              });

              this.$emit("diseaseResult:success");
            }
          } else {
            if (response.data.updateAnimalDisease) {
              this.$notify({
                title: `Disease updated successfully`,
                text: response.message,
                type: "success",
                position: "top right",
              });

              this.$emit("diseaseResult:success");
            }
          }
        })
        .catch((e) => {
          console.log(e);
          this.$notify({
            title: `Problem with Disease data.`,
            text: e.message,
            type: "error",
            position: "top right",
          });
        })
        .finally(() => {
          this.stopLoading();
        });
    },
  },
  mounted() {
    if (this.diseaseitem) {

      let diseaseDate = null;
      if (this.diseaseitem.diseaseDate) {
        diseaseDate = new Date(this.diseaseitem.diseaseDate);
        diseaseDate =
          diseaseDate.getFullYear() +
          "-" +
          diseaseDate.getMonth() +
          "-" +
          diseaseDate.getDate();

      }

      const last = this.diseaseitem.clinicalSymptoms.charAt(
        this.diseaseitem.clinicalSymptoms - 1
      );

      this.animalDisease.id = parseInt(this.diseaseitem.id);
      this.animalDisease.clinicalSymptoms =
        last == ","
          ? this.diseaseitem.clinicalSymptoms
          : this.diseaseitem.clinicalSymptoms + ",";
      this.animalDisease.tentativeDiagnosis =
        this.diseaseitem.tentativeDiagnosis;
      this.animalDisease.sampleCollected = this.sampleCollectedOptions.includes(this.diseaseitem.sampleCollected) ? this.diseaseitem.sampleCollected : 'Others'
      this.animalDisease.diseaseDate = diseaseDate;
      this.animalDisease.veterinarianName = this.diseaseitem.veterinarianName;
      this.animalDisease.otherSampleCollected =this.sampleCollectedOptions.includes(this.diseaseitem.sampleCollected) ? '' : this.diseaseitem.sampleCollected;
    }
  },
  props: ["dialogI", "diseaseitem"],
  mixins: [loading],
};
</script>
<style lang="scss" scoped>
.v-application .title {
  font-size: 16px !important;
  line-height: 0px !important;
  font-weight: normal;
}
::v-deep .scrollable-textarea .v-input__prepend-inner{
  flex-wrap: wrap !important;
}

::v-deep .scrollable-textarea .v-input__slot{
  display: block !important;
}
</style>
